var render, staticRenderFns
import script from "./RatingChart.vue?vue&type=script&lang=js"
export * from "./RatingChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f670f90')) {
      api.createRecord('8f670f90', component.options)
    } else {
      api.reload('8f670f90', component.options)
    }
    
  }
}
component.options.__file = "resources/js/components/app/RatingChart.vue"
export default component.exports